import {Injectable} from '@angular/core';
import {ShardHandlerService} from '../sharding/shard-handler.service';
import {NbThemeService} from '@nebular/theme';
import {ConfigService} from '../config/config.service'

@Injectable({
  providedIn: 'root',
})
export class BrandingService {

  public shard: string     = '';
  public textLogo: boolean = true;
  private themeNames       = [
    'vinea',
    'default',
  ]

  constructor(
    private shardService: ShardHandlerService,
    private themeService: NbThemeService,
    private config: ConfigService,
  ) {
    this.detectShard();
  }

  private detectShard() {
    const vm = this;
    this.shardService.get().then(data => {
      const forcedTheme = vm.config.get('forcedTheme');
      if (forcedTheme) {
        vm.shard = 'vinea';
      } else {
        vm.shard = data['data']['alias'];
      }

      if (this.themeNames.indexOf(vm.shard) > -1) {
        this.themeService.changeTheme(vm.shard);
        vm.textLogo = false;
      } else {
        this.themeService.changeTheme('default');
        vm.textLogo = true;
      }
    });
  }

  getBrandClass() {
    return this.shard + '-brand';
  }

  getLogo() {
    return '/assets/brands/' + this.shard + '/resources/icon-words.png';
  }
}
